import { Box, Card, CardContent, CssBaseline } from "@mui/material";
import { Navigate } from "react-router-dom";
import Copyrights from "../Components/Copyrights";
import Loader from "../Components/Loader";
import { useMicrospecDynamicUIContext } from "../GlobalProvider";
import { useTheme } from "@emotion/react";

const AuthWrapper = ({ children, autoRedirect = true, redirectTo }) => {
  const theme = useTheme();
  // Generate gradients from theme colors
  const backgroundGradient = theme.palette.mode === 'dark'
    ? `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`
    : `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.secondary.main} 100%)`;

  const { cloudProvider } = useMicrospecDynamicUIContext()
  const { user, loading } = cloudProvider
  if (loading) {
    return <Loader />;
  }
  if (user && autoRedirect) {
    redirectTo = redirectTo ? redirectTo : "/"
    return <Navigate to={redirectTo} replace />;
  }
  return <Box
    sx={{
      minHeight: '100vh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: backgroundGradient,
      margin: 0,
      padding: 0,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'auto'
    }}>
    <CssBaseline />
    <Card
      elevation={24}
      sx={{
        width: '100%',
        maxWidth: 450,
        borderRadius: 4,
        overflow: 'hidden',
        background: theme.palette.mode === 'dark'
          ? 'rgba(30, 30, 30, 0.95)'
          : 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        border: theme.palette.mode === 'dark'
          ? '1px solid rgba(255, 255, 255, 0.1)'
          : '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: theme.palette.mode === 'dark'
          ? '0 8px 32px rgba(0, 0, 0, 0.5)'
          : '0 8px 32px rgba(0, 0, 0, 0.1)'
      }}
    >
      <CardContent sx={{ p: 4 }}>
        {children}
      </CardContent>
    </Card>
    <Copyrights sx={{ 
      mt: 4, 
      color: theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.7)'
        : 'rgba(255, 255, 255, 0.8)' 
    }} />
  </Box>;
};

export default AuthWrapper;
